export const errorMessage = (error: Error): string => {
  return error.message
    .replace('GraphQL error: ', '')
    .replace('Validation failed: ', '')
}

export const signUpErrorMessage = (error: string) => {
  return error.replace(/[^a-zA-Z0-9\(\)\,\.]+/g, ' ')
}
